// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1szTz","footer__links-list":"footer_footer__links-list__1UwJL","link-container":"footer_link-container__1I5FF","footer-link":"footer_footer-link__1tcrz"};